import React, { useState,useEffect } from "react";
import { Switch } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { updateUI } from "../../../../../store/actions/deviceProfile";
import {fetchallAssetRequest, fetchalllocationRequest} from "../../../../../store/actions/deviceProfile"
import { Body, Title } from "@vds/typography";
import NonShipGatLoc from "./nonshipgatloc";
import NonShipBleLoc from "./nonshipbleloc";
import { DownOutlined, UpOutlined } from "@ant-design/icons";

function CreateNonShipDeviceProfileStep3() {
  const dispatch = useDispatch();
  const { formFields, nonshipsetalert,selectedDeviceProfile,filters,locationList } = useSelector((state) => ({
    formFields: state.deviceProfile.ui.form.fields,
     locationList: state.deviceProfile.data.locationList,
    nonshipsetalert:
      state.deviceProfile?.ui?.form?.fields?.nonshipstep3?.nonshipsetalert ?? null,
      selectedDeviceProfile: Array.isArray(
      state.deviceProfile.ui.form.deviceTypes
    )
      ? state.deviceProfile.ui.form.deviceTypes.filter(
          (deviceType) =>
            deviceType.value ===
            state.deviceProfile.ui.form.fields.step1.deviceType.value
        )
      : [],
  }));

  useEffect(() => {
    if(selectedDeviceProfile[0]?.devicemodel?.toLowerCase() === "gat"){
    dispatch(fetchallAssetRequest());
    }
     if(selectedDeviceProfile[0]?.devicemodel?.toLowerCase() === "ble"){
    //  if(selectedDeviceProfile[0]?.devicemodel?.toLowerCase() === "ble" && locationList ===undefined){
    dispatch(fetchalllocationRequest());
    }
    },[])

  const [expanded, setExpanded] = useState(false);
  const handleAutoResolve = (checked) => {
    if (checked) {
      setExpanded(true);
    } else {
      setExpanded(false);
    }

    dispatch(
      updateUI({
        key: "form",
        value: {
          fields: {
            ...formFields,
            nonshipstep3: {
              ...formFields.nonshipstep3,
              nonshipsetalert: checked,
            },
          },
        },
      })
    );
  };

  const handleArrowClick = () => {
    if (nonshipsetalert) {
      setExpanded((prev) => !prev);
    }
  };

  return (
    <>
      <div
        className="font-face-vzw"
        style={{ fontWeight: 700, fontSize: "30px" }}
      >
      {Array.isArray(selectedDeviceProfile) &&
      selectedDeviceProfile.length > 0 &&
      selectedDeviceProfile[0]?.devicemodel?.toLowerCase() === "gat"?"Additional alerts":"Location"}
      </div>
      <div
        className="d-flex flex-row justify-content-between align-items-center"
        style={{ padding: "8px 0px", marginTop: "24px", width: "100%" }}
      >
        {/* <div
          className="font-face-vzw"
          style={{ fontWeight: 700, fontSize: "20px" }}
        >
          Set alert
           <Body size="small">Asset count threshold</Body>
        </div> */}
        {Array.isArray(selectedDeviceProfile) &&
      selectedDeviceProfile.length > 0 &&
      selectedDeviceProfile[0]?.devicemodel?.toLowerCase() === "gat"?<div
          className="font-face-vzw"
          style={{ fontWeight: 700, fontSize: "20px" }}
        >
          Asset count
           <Body size="small">Set alert based on count of assets inside a zone</Body>
        </div>:<div
          className="font-face-vzw"
          style={{ fontWeight: 700, fontSize: "20px" }}
        >
          Set alert
       </div>}
        <div className="d-flex flex-row align-items-center gap-2">
          <Switch
            style={
              nonshipsetalert
                ? { backgroundColor: "#008331" }
                : { backgroundColor: "#d8dada" }
            }
            checked={nonshipsetalert}
            onChange={handleAutoResolve}
          />
          {nonshipsetalert ? (
            expanded ? (
              <UpOutlined
                style={{ fontSize: "16px", color: "#000", cursor: "pointer" }}
                onClick={handleArrowClick}
              />
            ) : (
              <DownOutlined
                style={{ fontSize: "16px", color: "#000", cursor: "pointer" }}
                onClick={handleArrowClick}
              />
            )
          ) : (
            <DownOutlined style={{ fontSize: "16px", color: "#d8dada" }} />
          )}
        </div>
      </div>
      {Array.isArray(selectedDeviceProfile) &&
      selectedDeviceProfile.length > 0 &&
      selectedDeviceProfile[0]?.devicemodel?.toLowerCase() === "gat"?expanded && <NonShipGatLoc />:expanded && <NonShipBleLoc />}
    </>
  );
}

export default CreateNonShipDeviceProfileStep3;